// routes
import { PATH_DASHBOARD } from "../../../routes/paths";
// components

import SvgIconStyle from "../../../components/SvgIconStyle";

// ----------------------------------------------------------------------

const getIcon = (name) => (
  <SvgIconStyle src={`/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  user: getIcon("ic_user"),
  ecommerce: getIcon("ic_ecommerce"),
  dashboard: getIcon("ic_dashboard"),
  master: getIcon("ic_master"),
  parent: getIcon("ic_parent"),
  report: getIcon("ic_report"),
  ticket: getIcon("ic_bug"),
  orderStatus: getIcon("ic_orderStatus"),
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: "general",
    items: [
      {
        title: "Dashboard",
        path: PATH_DASHBOARD.general.app,
        icon: ICONS.dashboard,
      },
      // {
      //   title: "Missing Items",
      //   path: PATH_DASHBOARD.general.tickets,
      //   icon: ICONS.ticket,
      // },
      {
        title: "Raised Ticket",
        path: PATH_DASHBOARD.general.raisedTicket,
        icon: ICONS.orderStatus,
      },
    ],
  },

   // MANAGEMENT
  // ----------------------------------------------------------------------
  {
    subheader: "Master Module",
    items: [
      // USER
      {
        title: "Master",
        path: PATH_DASHBOARD.master.root,
        icon: ICONS.master,

        children: [
          { title: "Category", path: PATH_DASHBOARD.master.category },
          { title: "Product", path: PATH_DASHBOARD.master.product },
          { title: "Package", path: PATH_DASHBOARD.master.package },
          {
            title: "Ticket Category",
            path: PATH_DASHBOARD.master.ticketCategory,
          },
        ],
      },
    ],
  },

  
  {
    subheader: "Reports Module",
    items: [
      // USER
      {
        title: "Order Reports",
        path: PATH_DASHBOARD.reports.root,
        icon: ICONS.report,

        children: [
          {
            title: "New Order",
            path: PATH_DASHBOARD.reports.newReport,
          },
          {
            title: "Student Wise Pending Order",
            path: PATH_DASHBOARD.reports.studentwisependingReport,
          },
          {
            title: "School Wise Pending Order",
            path: PATH_DASHBOARD.reports.schoolwisependingReport,
          },
          {
            title: "New & Pending Order",
            path: PATH_DASHBOARD.reports.newAndPending,
          },
          {
            title: "Product Order",
            path: PATH_DASHBOARD.reports.dateWiseReport,
          },
          {
            title: "Order Wise GST",
            path: PATH_DASHBOARD.reports.orderWiseGSTReport,
          },
          {
            title: "With GST",
            path: PATH_DASHBOARD.reports.salesWithGst,
          },

          {
            title: "Without GST",
            path: PATH_DASHBOARD.reports.salesWithOutGst,
          },
          {
            title: "Shipping",
            path: PATH_DASHBOARD.reports.shippingReport,
          },
          {
            title: "Sales",
            path: PATH_DASHBOARD.reports.salesReport,
          },
          {
            title: "Settlement",
            path: PATH_DASHBOARD.reports.settlementReport,
          },
        ],
      },
    ],
  },
];

export default navConfig;
